import { cx } from '@linaria/core';
import { avoidBreakSnapPoint } from '@provider/print';
import { Link, ExternalLinkIcon } from '@ui/kit';
import { link } from './link.style.js';
import { media } from './shared.style.js';
import { jsx } from 'react/jsx-runtime';

function LinkMedia(props) {
  return /*#__PURE__*/jsx(Link, {
    className: cx(media, link),
    icon: /*#__PURE__*/jsx(ExternalLinkIcon, {
      height: 16
    }),
    theme: "primary",
    href: props.node.url,
    target: "_blank",
    ...avoidBreakSnapPoint(),
    children: props.node.text
  });
}

export { LinkMedia };
//# sourceMappingURL=link.js.map
